export default {
  name: 'ms',
  el: {
    breadcrumb: {
      label: 'Breadcrumb',
    },
    colorpicker: {
      confirm: 'OK',
      clear: 'Jelas',
      defaultLabel: 'pemilih warna',
      description:
        'warna semasa ialah {warna}. tekan enter untuk memilih warna baharu.',
      alphaLabel: 'pilih nilai alfa',
      alphaDescription: 'alpha {alpha}, current color is {color}', // to be translated
      hueLabel: 'pick hue value', // to be translated
      hueDescription: 'hue {hue}, current color is {color}', // to be translated
      svLabel: 'pick saturation and brightness value', // to be translated
      svDescription:
        'saturation {saturation}, brightness {brightness}, current color is {color}', // to be translated
      predefineDescription: 'select {value} as the color', // to be translated
    },
    datepicker: {
      now: 'Sekarang',
      today: 'Hari ini',
      cancel: 'Batal',
      clear: 'Padam',
      confirm: 'OK',
      dateTablePrompt:
        'Gunakan kekunci anak panah dan masukkan untuk memilih hari dalam bulan tersebut',
      monthTablePrompt:
        'Gunakan kekunci anak panah dan masukkan untuk memilih bulan',
      yearTablePrompt:
        'Gunakan kekunci anak panah dan masukkan untuk memilih tahun',
      selectedDate: 'Tarikh yang dipilih',
      selectDate: 'Pilih tarikh',
      selectTime: 'Pilih masa',
      startDate: 'Tarikh Mula',
      startTime: 'Masa Mula',
      endDate: 'Tarikh Tamat',
      endTime: 'Masa Tamat',
      prevYear: 'Tahun Sebelumnya',
      nextYear: 'Tahun Depan',
      prevMonth: 'Bulan Sebelumnya',
      nextMonth: 'Bulan Depan',
      year: '',
      month1: 'Januari',
      month2: 'Februari',
      month3: 'Mac',
      month4: 'April',
      month5: 'Mei',
      month6: 'Jun',
      month7: 'Julai',
      month8: 'Ogos',
      month9: 'September',
      month10: 'Oktober',
      month11: 'November',
      month12: 'Disember',
      weeks: {
        sun: 'Ahd',
        mon: 'Isn',
        tue: 'Sel',
        wed: 'Rab',
        thu: 'Kha',
        fri: 'Jum',
        sat: 'Sab',
      },
      weeksFull: {
        sun: 'Ahad',
        mon: 'Isnin',
        tue: 'Selasa',
        wed: 'Rabu',
        thu: 'Khamis',
        fri: 'Jumaat',
        sat: 'Sabtu',
      },
      months: {
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mac',
        apr: 'Apr',
        may: 'Mei',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Okt',
        nov: 'Nov',
        dec: 'Dis',
      },
    },
    inputNumber: {
      decrease: 'mengurangkan',
      increase: 'meningkatkan',
    },
    select: {
      loading: 'Memuatkan',
      noMatch: 'Tiada data yang sepadan',
      noData: 'Tiada data',
      placeholder: 'Pilih',
    },
    mention: {
      loading: 'Memuatkan',
    },
    dropdown: {
      toggleDropdown: 'Togol Dropdown',
    },
    cascader: {
      noMatch: 'Tiada data yang sepadan',
      loading: 'Memuatkan',
      placeholder: 'Pilih',
      noData: 'Tiada data',
    },
    pagination: {
      goto: 'Pergi ke',
      pagesize: '/halaman',
      total: 'Jumlah {total}',
      pageClassifier: '',
      page: 'Halaman',
      prev: 'Halaman sebelumnya',
      next: 'Halaman seterusnya',
      currentPage: 'halaman {pager}',
      prevPages: 'Halaman {pager} sebelumnya',
      nextPages: 'Halaman {pager} seterusnya',
      deprecationWarning:
        'Penggunaan yang ditamatkan dikesan, sila rujuk dokumentasi el-pagination untuk butiran lanjut',
    },
    dialog: {
      close: 'Tutup dialog ini',
    },
    drawer: {
      close: 'Tutup dialog ini',
    },
    messagebox: {
      title: 'Mesej',
      confirm: 'OK',
      cancel: 'Cancel', // to be translated
      error: 'Input haram',
      close: 'Tutup dialog ini',
      Batal: 'Dibatalkan',
    },
    upload: {
      deleteTip: 'tekan padam untuk mengalih keluar',
      delete: 'Padam',
      preview: 'Pratonton',
      continue: 'Teruskan',
    },
    slider: {
      defaultLabel: 'peluncur antara {min} dan {maks}',
      defaultRangeStartLabel: 'pilih nilai mula',
      defaultRangeEndLabel: 'pilih nilai akhir',
    },
    table: {
      emptyText: 'Tiada Data',
      confirmFilter: 'OK',
      resetFilter: 'Reset',
      clearFilter: 'Semua',
      sumText: 'Jumlah',
    },
    tour: {
      next: 'Seterusnya',
      previous: 'Sebelumnya',
      finish: 'Selesai',
      close: 'Close this dialog', // to be translated
    },
    tree: {
      emptyText: 'Tiada Data',
    },
    transfer: {
      noMatch: 'Tiada data yang sepadan',
      noData: 'Tiada Data',
      titles: ['Senarai 1', 'Senarai 2'],
      filterPlaceholder: 'Masukkan kata kunci',
      noCheckedFormat: '{total} barang',
      hasCheckedFormat: '{checked}/{total} diperiksa',
    },
    image: {
      error: 'FAILED',
    },
    pageHeader: {
      title: 'Kembali',
    },
    popconfirm: {
      confirmButtonText: 'Ya',
      cancelButtonText: 'No', // to be translated
      BatalButtonText: 'Tidak',
    },
    carousel: {
      leftArrow: 'Anak panah karusel ke kiri',
      rightArrow: 'Anak panah karusel ke kanan',
      indicator: 'Tukar karusel kepada indeks {index}',
    },
  },
}
